import dynamic from "next/dynamic";
import MondayProductsHomepageFirstFoldConfig from "./monday-products-homepage-first-fold-config";
import MondayProductsHomepageFirstFoldAdvancedConfig from "./monday-products-homepage-first-fold-advanced-config";
const MondayProductsHomepageFirstFoldComponent = dynamic(()=>import("./monday-products-homepage-first-fold-component"));
export default {
    MondayProductsHomepageFirstFoldComponent,
    MondayProductsHomepageFirstFoldConfig,
    MondayProductsHomepageFirstFoldAdvancedConfig
};
